import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import {
  formatNotary,
  processNotaryResponse,
  formatOperationNotary,
  formatDatesAssigments,
} from './utils';

const NOTARY_URL = `${API_CONFIG.API}/node/notary`;
const FILTER_BY_NAME = `filter[name-filter][condition][path]=nt_nombre&
filter[name-filter][condition][operator]=STARTS_WITH&
filter[name-filter][condition][value]=`;
export const OPERATION_URL = `${API_CONFIG.API}/node/operation`;
export const DATESASSIGMENTS_URL = `${API_CONFIG.API}/node/date_assignement`;
export default {
  saveNotary(collaborator) {
    return base.http().post(`${NOTARY_URL}`, formatNotary(collaborator));
  },
  updateNotary(collaborator) {
    return base.http().patch(`${NOTARY_URL}/${collaborator.id}`, formatNotary(collaborator));
  },
  getAllNotaries() {
    return base.http().get(`${NOTARY_URL}`)
      .then(res => processNotaryResponse(res));
  },
  searchNotaryByName(name) {
    return base.http().get(`${NOTARY_URL}?${FILTER_BY_NAME}${name}`)
      .then(res => processNotaryResponse(res));
  },
  updateOperationNotary(model) {
    return base.http().patch(`${OPERATION_URL}/${model.op}`, formatOperationNotary(model));
  },
  updateDatesAssigments(model) {
    return base.http().patch(`${DATESASSIGMENTS_URL}/${model.date}`, formatDatesAssigments(model));
  },
};



// WEBPACK FOOTER //
// ./src/features/notary/service.js